import { Observable } from 'rxjs/Observable'
import { taskLoadSuccess } from './tasks'
import { getErrorAction } from './errorMapper'
import { mergeMap, map, catchError } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'

// Actions
export const TASK_FIELD_SAVE = 'TASK_FIELD_SAVE'
export const TASK_FIELD_SAVE_FAILURE = 'TASK_FIELD_SAVE_FAILURE'

// Action Creators
export const taskNameSave = (id, name, onError) =>
  taskFieldSave(id, 'name', name, onError)
export const taskDescriptionSave = (id, description, onError) =>
  taskFieldSave(id, 'description', description, onError)
export const taskAssignmentsSave = (id, assignments, onError) =>
  taskFieldSave(id, 'assignments', assignments, onError)

export const taskFieldSave = (id, fieldName, fieldValue, onError) => ({
  type: TASK_FIELD_SAVE,
  payload: { id, fieldName, fieldValue, onError }
})
export const taskFieldSaveFailure = payload => ({ type: TASK_FIELD_SAVE_FAILURE, payload, error: true })

// Epics
export const taskFieldSaveEpic = (action$, state$, { vapiClient }) =>
  action$.pipe(
    ofType(TASK_FIELD_SAVE),
    mergeMap(action =>
      vapiClient.setTaskField(
        state$.value.project.id,
        action.payload.id,
        action.payload.fieldName,
        action.payload.fieldValue
      ).pipe(
        map(ajaxResponse => taskLoadSuccess(ajaxResponse.response)),
        catchError(error => {
          action.payload.onError()
          return of(getErrorAction(error, taskFieldSaveFailure))
        })
      )
    )
  )



// WEBPACK FOOTER //
// ./src/store/taskFields.js